export default "__VITE_ASSET__CKq2XYx3__"